import { useEffect, useState } from "react";
import { MoreInfo } from "../../MoreInfo/MoreInfo";
import { Image } from "../../../Image/Image";

export const FichePublicatie = (props) => {
    const [bodyItems, setBodyItems] = useState([]);
    //Processs body items
    useEffect(() => {
        let items = props.processFicheItems(props.data.body.items);
        setBodyItems(items);
    }, [JSON.stringify(props.data.body.items)]);
    return (
        <div
            className={`c-fiche c-publication-full ${props.data?.hasDetail ? "u-has-detail" : ""}`}
            onClick={() => {
                if (props.data?.hasDetail && props.openPopup) {
                    props.openPopup(props.data.urlSegment);
                }
            }}
            data-aos="fade-up"
        >
            <div>
                <div className="image" title="Meer over">
                    {
                        props.data?.image?.url && <Image alt={(props.data.image?.alt ?? "")} src={(props.data.image.url)} />
                    }
                </div>
                <header className="c-fiche__header">
                    {(props.data.tagIcon &&
                        <div className="c-tag-list">
                            <div className="c-tag" title="coronaproof">
                                <Image alt={props.data.title} src={props.data.tagIcon.url} />
                            </div>
                        </div>)}
                    <h2 className="title" title={props.title}>
                        {props.data.title}
                    </h2>
                    {props.data.text}
                </header>
                <div className="c-fiche__body">
                    <ul>
                        {bodyItems}
                    </ul>
                </div>
                <MoreInfo
                    data={props.data}
                    openPopup={props.openPopup}
                    cta={props.dictionary.moreInfo}
                />
            </div>
        </div>
    );
}